import { render, staticRenderFns } from "./checkbox-widget.vue?vue&type=template&id=262108c1&scoped=true"
import script from "./checkbox-widget.vue?vue&type=script&lang=js"
export * from "./checkbox-widget.vue?vue&type=script&lang=js"
import style0 from "./checkbox-widget.vue?vue&type=style&index=0&id=262108c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262108c1",
  null
  
)

export default component.exports